var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    viewBox: "0 -2 19 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1c0 .65 3 5 8.5 5S18 .65 18 0h1c0 1.55-4 6-9.5 6S0 1.545 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.323 2.35l-.743.67 2.677 2.972.743-.67-2.677-2.972zM13.53 4.2l-.93.367 1.466 3.72.93-.365L13.53 4.2zM9 5h1v4H9V5zm-3.534-.8l.93.367-1.466 3.72L4 7.923 5.466 4.2zm-2.79-1.85l.744.67L.743 5.99 0 5.322 2.677 2.35z"
  }))));
};
export default SvgEyeClosed;